import React, { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";


export default function TiptapEditor({ value, onChange }) {

    const editor = useEditor({
        extensions: [
            StarterKit,
            Link.configure({
                openOnClick: false,
            }),
        ],
        content: value,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
    });

    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value || "");
        }
    }, [value, editor]);

    if (!editor) return null;

    return (
        <>
            <div className="toolbar">

                {/*<button*/}
                {/*    type="button"*/}
                {/*    onClick={() => editor.chain().focus().toggleBold().run()}*/}
                {/*>*/}
                {/*    B*/}
                {/*</button>*/}

                {/*<button*/}
                {/*    type="button"*/}
                {/*    onClick={() => editor.chain().focus().toggleItalic().run()}*/}
                {/*>*/}
                {/*    I*/}
                {/*</button>*/}

                {/*<button*/}
                {/*    type="button"*/}
                {/*    onClick={() => editor.chain().focus().toggleBulletList().run()}*/}
                {/*>*/}
                {/*    •*/}
                {/*</button>*/}

                {/*<button*/}
                {/*    type="button"*/}
                {/*    onClick={() => editor.chain().focus().toggleOrderedList().run()}*/}
                {/*>*/}
                {/*    1.*/}
                {/*</button>*/}

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                >
                    Podnaslov
                </button>

                <button
                    style={{ backgroundColor: "rgba(109, 161, 109, 0.75)" }}
                    type="button"
                    onClick={() => {
                        const url = window.prompt("Vnesi URL:");

                        if (url) {
                            editor
                                .chain()
                                .focus()
                                .extendMarkRange("link")
                                .setLink({
                                    href: url,
                                })
                                .run();
                        }
                    }}
                >
                    Dodaj Link
                </button>


                {/*<button*/}
                {/*    style={{ backgroundColor: "indianred" }}*/}
                {/*    type="button"*/}
                {/*    onClick={() =>*/}
                {/*        editor*/}
                {/*            .chain()*/}
                {/*            .focus()*/}
                {/*            .unsetLink()*/}
                {/*            .run()*/}
                {/*    }*/}
                {/*>*/}
                {/*    Odstrani Link*/}
                {/*</button>*/}

            </div>

            <EditorContent editor={editor} />
        </>
    );
}